import {Component} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector:'popup',
    templateUrl:'./map-popup.component.html',
    styleUrls: ['./map-popup.component.scss']
})

export class MapPopupComponent {
    constructor(){}
    
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mapPopup/map-popup.component.ts